import React, { useState } from "react";
import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const models = [
  { name: "Daisy", category: "Display", image: "images/newdaisy.jpg", description: "An elegant, user-friendly model, designed to fit in both modern and classic coffee shops.", route: "/daisy-lower" },
  { name: "Vista", category: "Display", image: "images/vista2.jpg", description: "This model offers versatile display options for coffee shops. Its sleek design integrates seamlessly into modern settings.", route: "/vista" },
  { name: "Minimal", category: "Display", image: "images/newminimal1.jpg", description: "Minimalistic design with powerful features, perfect for small and intimate coffee spaces.", route: "/minimal" },
  { name: "Fresco Combi", category: "Semi-Verticals", image: "images/fresco.jpg", description: "An innovative model that combines modern display techniques with ergonomic functionality.", route: "/FrescoCombi-lower" },
  { name: "United", category: "Multi decks", image: "images/united.png", description: "A multi-functional model that is perfect for busy coffee shops and bakeries with diverse needs.", route: "/united" },
  { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistagrabgo.jpg", description: "Perfect for fast-service coffee shops with a modern, grab-and-go concept.", route: "/vista-grab-and-go" },
  { name: "E-Line", category: "Display", image: "images/neweline.jpg", description: "Elegant design offering compact solutions for a modern, stylish coffee setup.", route: "/e-line" },
  { name: "Iris", category: "Display", image: "images/newiris.jpg", description: "Sleek, contemporary display with a focus on simplicity and functionality for any coffee space.", route: "/iris" },
  { name: "Kubo", category: "Display", image: "images/newkubo.jpg", description: "Modern design with a minimal footprint, ideal for high-traffic areas in cafes.", route: "/kubo" },
  { name: "Daisy", category: "Display", image: "images/daisy2.jpg", description: "An elegant, user-friendly model, designed to fit in both modern and classic coffee shops.", route: "/daisy-upper" },
  { name: "Futuro 2", category: "Semi-Verticals", image: "images/futuro2.jpg", description: "Futuristic design with compact, efficient use of space, ideal for high-demand settings.", route: "/Futuro-2" },
  { name: "Urban", category: "More solutions", image: "images/urban.jpg", description: "Urban-styled model offering practical and compact design suitable for modern coffee environments.", route: "/urban" },
  // { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "A premium model designed to suit the needs of modern coffee shops with high foot traffic.", route: "/victory" }
];

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

function CofeeShop() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();
  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/coffeeland.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Coffee Shop</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          A world of solutions for service in modern Coffee Shops. Find here everything you need for a successful business.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Coffee shop</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}

export default CofeeShop;





// import React from 'react'

// function CofeeShop() {
//   return (
//     <div>
//        <section 
//   className="relative text-center w-full h-screen"
//   style={{
//     backgroundImage: "url('images/coffeeland.jpg')",
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     backgroundRepeat: 'no-repeat'
//   }}
// >
//   <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//     <h1 className="text-4xl font-thin mb-4 md:text-8xl">Coffee Shop</h1>
//     <p className="text-lg max-w-2xl md:text-3xl">
//       A world of solutions for service in modern Coffee Shops. Find here everything you need for a successful business.
//     </p>
//   </div>
// </section>
   
// <div className="flex flex-col xl:gap-20 xl:px-20">
//   {/* Header Section */}
//   <header className="text-center pt-20">
//     <h1 className="text-4xl md:text-5xl lg:text-7xl xl:text-8xl font-thin text-gray-900 mb-8">
//       Coffee Shop Equipment<br/> Solutions
//     </h1>
//   </header>

//   {/* Equipment Categories */}
//   <section className="mb-16 px-3 flex flex-col xl:flex-row gap-6 xl:gap-20 justify-between items-center">
//     <h2 className="text-2xl md:text-6xl  2xl:text-7xl font-thin text-gray-800 text-center">
//       Elevate Your Coffee Business with Our Equipment
//     </h2>
//     <p className="text-xl md:text-2xl 2xl:text-4xl text-gray-700 xl:max-w-2xl 2xl:max-w-3xl text-justify">
//       We provide a comprehensive range of coffee shop equipment designed to enhance efficiency, 
//       presentation, and customer satisfaction. From stylish display units to high-performance multi-decks, 
//       our solutions cater to all your business needs.
//     </p>
//   </section>

//   {/* Display Solutions */}
 

//   <section className="mb-16 px-3 xl:p-20 flex flex-col xl:flex-row gap-10 md:gap-20 justify-center items-center bg-gradient-to-r from-gray-800 to-zinc-300 py-16 rounded-xl shadow-lg">
//   <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-thin text-white text-center drop-shadow-lg">
//     Display Solutions
//   </h2>
//   <p className="text-xl md:text-2xl 2xl:text-4xl text-white xl:max-w-2xl 2xl:max-w-3xl text-justify mt-6 opacity-90">
//     Showcase your products in style with our advanced display solutions, designed to keep 
//     your offerings fresh and visually appealing. Our display units include:
//   </p>
// </section>


// <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 px-3 mt-12">
//   {/* Card 1: Vista */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden">
//     <div className="relative w-full h-72">
//       <img
//         src="images/vista.jpg"
//         alt="Vista Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Vista</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           Experience sleek and futuristic design with the Vista series. Perfect for modern spaces.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 2: Minimal */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/minimal.jpg"
//         alt="Minimal Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Minimal</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           Embrace simplicity with the Minimal series, designed for elegance and functionality.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 3: E-Line */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/eline.jpg"
//         alt="E-Line Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">E-Line</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           Efficient and ergonomic, the E-Line series is built for high performance and durability.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 4: Iris */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/iris.jpg"
//         alt="Iris Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Iris</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           The Iris series blends sophistication and functionality for a truly elegant display experience.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 5: Kubo */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/kubo.jpg"
//         alt="Kubo Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Kubo</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           The Kubo series offers innovative design with modular features, ideal for any retail environment.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 6: Daisy */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden">
//     <div className="relative w-full h-72">
//       <img
//         src="images/daisy.png"
//         alt="Daisy Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Daisy</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           Bring natural beauty to your space with the Daisy series, featuring floral-inspired designs.
//         </p>
//       </div>
//     </div>
//   </div>
// </div>


//   {/* Multi-Deck Solutions */}

//   <section className=" px-3 flex flex-col  xl:flex-row gap-5 xl:gap-20 justify-center items-center  py-16  mt-12">
//   <div className="flex flex-col  xl:p-12 items-center text-center">
//     <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-thin text-black mb-4 drop-shadow-lg">
//       Multi-Deck Solutions
//     </h2>
//     <p className="text-xl md:text-2xl 2xl:text-4xl text-black xl:max-w-2xl 2xl:max-w-3xl opacity-90">
//       Our multi-deck units provide ample storage while ensuring optimal product visibility and accessibility, 
//       making them ideal for high-traffic environments.
//     </p>
//   </div>

// {/* Card 1 */}
// <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-96">
//       <img
//         src="images/united.png"
//         alt="Daisy Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">United</h3>
//         <p className="text-lg text-white opacity-90 mt-4 max-w-sm">
//   The United Multi Deck display offers superior visibility and efficient organization, eye-catching product presentation with easy access for a wide range of items.
// </p>
//       </div>
//     </div>
//   </div>
// </section>


//  {/* Additional Solutions */}
// <section className=" px-3 flex flex-col  xl:flex-row gap-5 xl:gap-20 justify-center items-center   ">
//   {/* Card 1 */}
// <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-96">
//       <img
//         src="images/united.png"
//         alt="Daisy Display"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Urban</h3>
//         <p className="text-lg text-white opacity-90 mt-4 max-w-sm text-justify">
//    United Multi Deck display offers superior visibility and efficient organization, eye-catching product presentation with easy access for a wide range of items.

// </p>
//       </div>
//     </div>
//   </div>
//   <div className="flex flex-col  xl:p-12 items-center text-center">
//     <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-thin text-black mb-4 drop-shadow-lg">
//     More Solutions
//     </h2>
//     <p className="text-xl md:text-2xl 2xl:text-4xl text-black xl:max-w-2xl 2xl:max-w-3xl opacity-90">
//     Our additional solutions help you create an inviting and efficient environment, enhancing both 
//     customer experience and operational performance.
//     </p>
//   </div>


// </section>




//   {/* Semi-Vertical Solutions */}
//   <section className=" px-3 flex flex-col xl:flex-row gap-5 xl:gap-20 justify-between items-center bg-gradient-to-r from-gray-800 to-zinc-300 py-16 rounded-xl shadow-lg mt-12">
//   <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-thin text-white mb-4 text-center drop-shadow-lg">
//     Semi-Vertical Solutions
//   </h2>
//   <p className="text-xl md:text-2xl 2xl:text-4xl text-white xl:max-w-2xl 2xl:max-w-3xl text-justify opacity-90">
//     Our semi-vertical units provide a perfect balance of space-saving design and accessibility, 
//     ensuring maximum efficiency in any coffee shop setup. Our range includes:
//   </p>
// </section>

// <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 px-3 mb-12">
//   {/* Card 1: Fresco Combi */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/freesco.jpg"
//         alt="Semi-Verticals > Fresco Combi"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Fresco Combi</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           A versatile semi-vertical display solution perfect for showcasing a range of products with optimal visibility and accessibility.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 2: Daisy */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/daisy.png"
//         alt="Semi-Verticals > Daisy"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Daisy</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           Enhance your product presentation with this sleek and compact semi-vertical display, designed to showcase smaller items elegantly.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 3: Vista Grab & Go */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/vistagrab.png"
//         alt="Semi-Verticals > Vista Grab & Go"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Vista Grab & Go</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           A grab-and-go solution designed for high-traffic areas, perfect for quick product access while maintaining a clean, organized display.
//         </p>
//       </div>
//     </div>
//   </div>

//   {/* Card 4: Futuro 2 */}
//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/futuro.jpg"
//         alt="Semi-Verticals > Futuro 2"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Futuro 2</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//           Modern and flexible, Futuro 2 offers enhanced visibility and easy access, ideal for high-end product displays.
//         </p>
//       </div>
//     </div>
//   </div>

//   <div className="group relative transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-xl rounded-xl overflow-hidden ">
//     <div className="relative w-full h-72">
//       <img
//         src="images/victory.png"
//         alt="Semi-Verticals > victory"
//         className="w-full h-full object-contain rounded-t-xl"
//       />
//     </div>
//     <div className="relative z-10 p-6">
//       <div className="bg-gradient-to-r from-gray-800 to-zinc-300 backdrop-blur-md rounded-xl p-4">
//         <h3 className="text-2xl font-thin text-white">Victory</h3>
//         <p className="text-lg text-white opacity-90 mt-4">
//         Stylish and adaptable, the Victory display offers exceptional visibility and effortless access, .        </p>
//       </div>
//     </div>
//   </div>
// </div>
// </div>
//     </div>
//   )
// }

// export default CofeeShop